// utils/axiosInstance.js
import axios from 'axios';

// Create an Axios instance
const axiosInstance = axios.create({
  headers: {
    "Content-Type": "application/json",
  }
});

// Response interceptor to handle 401 errors
axiosInstance.interceptors.response.use(response => response, error => {
  if (error.response && error.response.status === 401) {
    // Handle 401 errors
    localStorage.removeItem('token');
    window.location.href = '/login';
  }
  return Promise.reject(error);
});

export default axiosInstance;